/**
 *  @fileOverview Slider module, initalises Glide Slider instances
 *
 *  @author       Chris Hill
 *
 */

function SliderModule (Glide) {
  /**
   * @description Initialises glide slider instances.
   *
   * @param {string} target - Target Div to initiate slider.
   * @example
   * //
   * @returns {boolean} // null.
   */
  this.init = function (target) {
    var nodes = document.querySelectorAll(target)
    var sliders = []

    nodes.forEach((element, index) => {
      let total = element.querySelectorAll('.glide__slide').length
      /**
       * Only initialise if there are slides
       */
      if (total > 0) {
        element.id = target.indexOf('.glide') > -1 ? 'glide_' + index : 'event_' + index

        let breakpoints = {}
        let items = 1
        let gap = 32
        let type = 'slider'
        let adjustheight = false
        let bullets = false
        let hidenumbers = false

        /**
         * Check for gap and update
         */
        if (typeof element.dataset.gap !== 'undefined') {
          gap = parseInt(element.dataset.gap)
        }

        /**
         * Check for items and update items perView var
         */
        if (typeof element.dataset.items !== 'undefined') {
          items = parseInt(element.dataset.items)
        }

        /**
         * Check for type and update type var
         */
        if (typeof element.dataset.type !== 'undefined') {
          type = element.dataset.type
        }

        /**
         * Check for breakpoints data attribute and replace single quotes with double before converting to object
         */
        if (typeof element.dataset.breakpoints !== 'undefined') {
          let s = element.dataset.breakpoints
          s = s.replace(/'/g, '"')

          if (validJSON(s)) {
            breakpoints = JSON.parse(s)
          } else {
            console.log('Warning!! Invalid JSON string in slider data-breakpoint attribute.')
          }
        }

        /**
         * Check for adjustheight and update
         */
        if (typeof element.dataset.adjustheight !== 'undefined') {
          adjustheight = true
        }

        /**
         * Check for bullets or type as carousel and update
         */
        if (typeof element.dataset.bullets !== 'undefined' && type !== 'carousel') {
          bullets = true
        }

        /**
         * Check for adjustheight and update
         */
        if (typeof element.dataset.hidenumbers !== 'undefined') {
          hidenumbers = true
        }

        if (bullets) {
          /**
           * Build HTML for bullet nav
           */
          let html = `<div class="glide__bullets" data-glide-el="controls[nav]">`

          for (let i = 0; i < total; i++) {
            html += `<button class="glide__bullet" data-glide-dir="=${i}" aria-label="Slide transition ${i + 1}"><i class="fas fa-circle"></i></button>`
          }

          html += `</div>`

          element.innerHTML += html
        }

        /**
         * Initialise the glide element
         */
        sliders[index] = new Glide(element, {
          type: type, // Must be carousel for the calculate height to work
          startAt: 0,
          perView: items,
          perSwipe: '|',
          animationDuration: 500,
          animationTimingFunc: 'ease-in',
          gap: gap,
          breakpoints: breakpoints,
          bound: true
        })

        /**
         * Run as soon at the slider has been mounted
         */
        sliders[index].on('mount.after', function () {
          /**
           * Create the slide count element and populate
           */
          if (type !== 'carousel' && !hidenumbers) {
            const transitions = Math.ceil(parseFloat(total / sliders[index].settings.perView))
            let btn = element.querySelector('.glide__arrow--left')
            let scount = document.createElement('span')
            scount.setAttribute('class', 'glide__slideCount')
            scount.setAttribute('aria-label', '1 out of ' + transitions + ' slides')
            scount.innerHTML = '1 / ' + transitions
            btn.parentNode.insertBefore(scount, btn.nextSibling)
            element.querySelector('.glide__slide--active').setAttribute('aria-current', true)
          }

          calcHeight(element, total, sliders[index].settings, adjustheight)

          if (bullets) {
            buildNav(element, total, sliders[index].settings)
          }

          element.querySelector('.glide__arrow--left').setAttribute('data-glide-dir', '|<')
          element.querySelector('.glide__arrow--right').setAttribute('data-glide-dir', '|>')
          // calcArrows(element, total, sliders[index].settings)

          /**
           * Disable slider and hide nav if there are not enough elements to slide
           */
          const t = element.querySelectorAll('.glide__slide:not(.glide__slide--clone)').length
          if (t <= sliders[index].settings.perView) {
            sliders[index].disable()
            // element.querySelector('.glide__track').classList.add('glide__track--noSlide')
            element.querySelector('.glide__arrows').style.display = 'none'
            if (bullets) {
              element.querySelector('.glide__bullets').style.display = 'none'
            }
          }

          /**
           * Hide clone slides from screen readers
           */
          let clones = element.querySelectorAll('.glide__slide--clone')

          clones.forEach((clone) => {
            clone.setAttribute('aria-hidden', true)
          })
        })

        /**
         * Run every time a slide happens
         */
        sliders[index].on('run', function () {
          /**
           * Update slide count with updates number
           */
          if (type !== 'carousel' && !hidenumbers) {
            const transitions = Math.ceil(parseFloat(total / sliders[index].settings.perView))
            let current = Math.ceil((sliders[index].index + sliders[index].settings.perView) / sliders[index].settings.perView)
            element.querySelector('.glide__slideCount').innerHTML = `${current} / ${transitions}`
            element.querySelector('.glide__slideCount').setAttribute('aria-label', `${current} out of ${transitions} slides`)
          }

          /**
           * Define a custom event that the youtubeModule will listen for to pause and youtube videos in the current slider
           */
          /* eslint-disable-next-line no-undef */
          const awesomeEvent = new CustomEvent('pauseyoutube', {
            detail: element.id
          })

          window.dispatchEvent(awesomeEvent)
        })

        /**
         * Run after every time a slide happens
         */
        sliders[index].on('run.after', function () {
          /**
           * Loop through slides and remove aria-current from non active slide then set for active
           */

          let slides = element.querySelectorAll('.glide__slide')

          slides.forEach((slide) => {
            slide.removeAttribute('aria-current')
            slide.removeAttribute('aria-hidden')
          })

          element.querySelector('.glide__slide--active').setAttribute('aria-current', true)

          /**
           * Hide clone slides from screen readers
           */
          let clones = element.querySelectorAll('.glide__slide--clone')

          clones.forEach((clone) => {
            clone.setAttribute('aria-hidden', true)
          })

          calcHeight(element, total, sliders[index].settings, adjustheight)
          // calcArrows(element, total, sliders[index].settings)
        })

        /**
         * Run on window resize
         */
        sliders[index].on('resize', function () {
          /**
           * If total less or equal the current view itemns perView hide buttons
           */
          /* if (total <= sliders[index].settings.perView) {
            element.querySelector('.glide__arrows').style.display = 'none'
          } else {
            element.querySelector('.glide__arrows').style.display = 'block'
          } */
          calcHeight(element, total, sliders[index].settings, adjustheight)
          if (bullets) {
            buildNav(element, total, sliders[index].settings)
          }
          // calcArrows(element, total, sliders[index].settings)

          /**
           * Disable slider if all sides are visible
           */
          const t = element.querySelectorAll('.glide__slide:not(.glide__slide--clone)').length
          if (t <= sliders[index].settings.perView) {
            // element.querySelector('.glide__track').classList.add('glide__track--noSlide')
            element.querySelector('.glide__arrows').style.display = 'none'
            if (bullets) {
              element.querySelector('.glide__bullets').style.display = 'none'
            }

            sliders[index].disable()
          } else {
            // element.querySelector('.glide__track').classList.remove('glide__track--noSlide')
            element.querySelector('.glide__arrows').style.display = 'flex'
            if (bullets) {
              element.querySelector('.glide__bullets').style.display = 'flex'
            }

            sliders[index].enable()
          }
        })

        sliders[index].mount()

        window.addEventListener('orientationchange', calcHeight(element, total, sliders[index].settings, adjustheight))

        onImagesLoaded(element, function () {
          calcHeight(element, total, sliders[index].settings, adjustheight)
        })

        onFontsLoaded(element, function () {
          calcHeight(element, total, sliders[index].settings, adjustheight)
        })
      }
    })

    /**
     * @description Calls event after images have loaded.
     *
     * @param {Object} container - The container DOM node.
     * @param {Object} event - The event to call.
     *
     * @example //
     */
    function onImagesLoaded (container, event) {
      var images = container.getElementsByTagName('img')
      var loaded = images.length
      for (var i = 0; i < images.length; i++) {
        if (images[i].complete) {
          loaded--
        } else {
          images[i].addEventListener('load', function () {
            loaded--
            if (loaded === 0) {
              event()
            }
          })
        }
        if (loaded === 0) {
          event()
        }
      }
    }

    function onFontsLoaded (container, event) {
      let htmlTag = document.querySelector('html')
      let checkFontExists = function () {
        if ((htmlTag.classList.contains('wf-active') || htmlTag.classList.contains('wf-inactive')) && htmlTag.classList.contains('fontawesome-i2svg-active')) {
          event()
        } else {
          window.requestAnimationFrame(checkFontExists)
        }
      }

      checkFontExists()
    }

    /**
     * @description Calculates the height for the glide container based on either the first slide or next animating slide.
     *
     * @param {Object} element - The slide DOM node.
     * @param {number} total - The total number of slides.
     * @param {Object} settings - The glide settings.
     * @param {boolean} adjustheight - Wether to dynamical change height to fit currently displayed slides.
     *
     * @example //
     */
    function calcHeight (element, total, settings, adjustheight) {
      let height = element.querySelector('.glide__slide--active').offsetHeight
      let track = element.querySelector('.glide__track').style.height === '' ? 0 : element.querySelector('.glide__track').style.height
      let slides = element.querySelectorAll('.glide__slide')

      if (adjustheight) {
        /**
         * Calculate the height of the current slide element
         */
        if (settings.perView === 1) {
          height = element.querySelector('.glide__slide--active').offsetHeight
        } else {
          /**
           * Look at all slides in view and get the largest height
           */
          slides.forEach((slide, index) => {
            if (slide.classList.contains('glide__slide--active')) {
              /*
               * If using carousel
               */
              let vis = index + settings.perView

              if (settings.type === 'slider') {
                vis = index + settings.perView <= total ? index + settings.perView : total
              }
              let h = 0
              /**
               * Look at all slides in view and get the largest height
               */
              for (let i = index; i < vis; i++) {
                if (slides[i].offsetHeight > h) {
                  h = slides[i].offsetHeight
                }
              }
              height = h
            }
          })
        }
      } else {
        slides.forEach((slide, index) => {
          if (slide.offsetHeight > height) {
            height = slide.offsetHeight
          }
        })
      }

      if (height !== track) {
        element.querySelector('.glide__track').style.height = height + 'px'
      }
    }

    /**
     * @description Builds the slide navigation.
     *
     * @param {Object} element - The slide DOM node.
     * @param {number} total - The total number of slides.
     * @param {Object} settings - The glide settings.
     *
     * @example //
     */
    function buildNav (element, total, settings) {
      /**
       * Build HTML for bullet nav
       */
      const transitions = Math.ceil(parseFloat(total / settings.perView))
      const bullets = element.querySelectorAll('.glide__bullet')

      bullets.forEach((bullet) => {
        bullet.classList.remove('visuallyHidden')
        bullet.removeAttribute('aria-hidden', 'true')
      })

      /**
       * Check if perView is 1 then show all bullets otherwise hide every nth bullet
       */
      if (settings.perView !== 1) {
        bullets.forEach((bullet, index) => {
          if (transitions !== 1) {
            if (index !== 0 && index % settings.perView !== 0) {
              if (index + settings.perView !== total) {
                bullet.classList.add('visuallyHidden')
                bullet.setAttribute('aria-hidden', 'true')
              }
            } else {
              if (index + settings.perView > total) {
                bullet.classList.add('visuallyHidden')
                bullet.setAttribute('aria-hidden', 'true')
              }
            }
          }
        })
      }
    }

    /**
     * @description Updates the arrow increments.
     *
     * @param {Object} element - The slide DOM node.
     * @param {number} total - The total number of slides.
     * @param {Object} settings - The glide settings.
     *
     * @example //
     */
    /* function calcArrows (element, total, settings) {
      const slides = element.querySelectorAll('.glide__slide:not(.glide__slide--clone)')
      const arrowleft = element.querySelector('.glide__arrow--left')
      const arrowright = element.querySelector('.glide__arrow--right')

      if (settings.perView !== 1) {
        slides.forEach((slide, index) => {
          if (slide.className.includes('glide__slide--active')) {
            let forward = index + settings.perView < total ? index + settings.perView : 0
            let backward = index - settings.perView
            let transitionCount = Math.ceil(total / settings.perView)
            if (index - settings.perView < 0) {
              backward = (transitionCount * settings.perView) - settings.perView // Math for array position of last transition position
            } else {
              backward = index - settings.perView
            }
            arrowleft.setAttribute('data-glide-dir', '=' + backward)
            arrowright.setAttribute('data-glide-dir', '=' + forward)
          }
        })
      } else {
        arrowleft.setAttribute('data-glide-dir', '<')
        arrowright.setAttribute('data-glide-dir', '>')
      }
    } */

    /**
     * @description Checks a string is a valid JSON object.
     *
     * @param {string} str - String to check.
     *
     * @example
     * // returns true
     * @returns {boolean} True if valid JSON.
     */
    function validJSON (str) {
      try {
        JSON.parse(str)
      } catch (e) {
        return false
      }
      return true
    }
  }
}

module.exports = SliderModule
